const id = {
    "sc_title": "Pusat Keamanan",
    "sc_subtitle": "Lapisan Keamanan Terintegrasi GaiaShield",
    "sc_tab_status": "🛡️ Status Perlindungan",
    "sc_tab_events": "📋 Log Keamanan",
    "sc_tab_node": "⚙️ Keamanan Node",
    "sc_loading": "Memuat data keamanan...",
    "sc_status_secured": "Status Sistem: Akun terlindungi",
    "sc_status_warning": "Status Sistem: Peringatan aktif",
    "sc_desc_secured": "Tidak ada peringatan keamanan kritis yang aktif. GaiaShield secara aktif memantau akun Anda.",
    "sc_desc_warning": "Perhatian: Ada kejadian keamanan aktif yang memerlukan perhatian Anda.",
    "sc_account_protection": "Perlindungan Akun",
    "sc_message_protection": "Perlindungan Pesan",
    "sc_audits": "Audit Keamanan",
    "sc_active": "AKTIF",
    "sc_failed_logins": "Gagal Login",
    "sc_tamper_checks": "Pemeriksaan Modifikasi",
    "sc_blocked_replays": "Replay yang Diblokir",
    "sc_last_check": "Pemeriksaan Terakhir",
    "sc_just_now": "Baru saja",
    "sc_open_warnings": "Peringatan Terbuka",
    "sc_btn_acknowledge": "Konfirmasi",
    "sc_filter_severity": "Tingkat Keparahan",
    "sc_filter_category": "Kategori",
    "sc_filter_hide_ack": "Sembunyikan yang Dikonfirmasi",
    "sc_btn_export": "Ekspor",
    "sc_col_details": "Detail",
    "sc_col_time": "Waktu",
    "sc_col_status": "Status",
    "sc_col_action": "Tindakan",
    "sc_no_events": "Kejadian keamanan tidak ditemukan.",
    "sc_node_title": "Konsol Keamanan Operator Node",
    "sc_system_health": "Kesehatan Sistem",
    "sc_last_audit": "Audit Terakhir",
    "sc_packed_logs": "Log yang Dikompres",
    "sc_unconfirmed_events": "Kejadian yang Belum Dikonfirmasi",
    "sc_operator_action": "Tindakan Operator Diperlukan",
    "sc_all_ok": "Semua OK",
    "sc_critical_events": "Kejadian Sistem Kritis",
    "ac_title": "Pusat Tata Kelola & Pelaporan",
    "ac_subtitle": "Konsensus Tata Kelola & Pelaporan GaiaCom",
    "ac_tab_my_reports": "Laporan Saya",
    "ac_tab_queue": "Antrean Peninjauan",
    "ac_tab_operator": "Operator Node",
    "ac_tab_transparency": "Federasi & Transparansi",
    "ac_loading": "Memuat data...",
    "ac_reported_cases": "Kasus yang Dilaporkan",
    "ac_no_reports": "Anda belum mengirimkan laporan apa pun.",
    "ac_case_details": "Detail Kasus",
    "ac_appeal_submit": "Ajukan Banding",
    "ac_appeal_status": "Status Banding",
    "ac_appeal_reason": "Alasan Banding",
    "ac_appeal_statement": "Pernyataan",
    "ac_btn_appeal": "Kirim Banding",
    "ac_trusted_reviewer_queue": "Antrean Peninjau Terpercaya",
    "ac_case_review": "Tinjau Kasus",
    "ac_review_category": "Kategori yang Direkomendasikan",
    "ac_review_severity": "Tingkat Keparahan yang Direkomendasikan",
    "ac_review_action": "Tindakan yang Direkomendasikan",
    "ac_review_reason": "Alasan Peninjau",
    "ac_btn_submit_review": "Kirim Tinjauan",
    "ac_node_operator_dashboard": "Dasbor Operator Node",
    "ac_apply_action": "Terapkan Tindakan (Override)",
    "ac_target_type": "Tipe Target",
    "ac_target_id": "ID Target (GaiaID atau ID Saluran)",
    "ac_suspend": "Tangguhkan aktif",
    "ac_reason": "Alasan Resmi",
    "ac_btn_apply": "Terapkan Tindakan",
    "ac_transparency_title": "Buku Log Konsensus & Transparansi",
    "ac_transparency_desc": "Bukti snapshot yang dapat dilihat publik dari semua saluran dan identitas yang dimoderasi.",
    "ac_btn_snapshot": "Buat Snapshot Transparansi",
    "search_placeholder": "Cari email berdasarkan subjek, pengirim, teks...",
    "abuse_center_title": "Pusat Penyalahgunaan",
    "abbrechen": "Membatalkan",
    "active_identities": "Identitas aktif",
    "active_identity": "Identitas aktif",
    "add_btn": "Menambahkan",
    "add_contact_title": "Tambahkan kontak",
    "admin": "Admin",
    "adressbuch": "direktori",
    "aktiviert": "Diaktifkan",
    "an": "Ke",
    "anonymous_sender": "Pengirim anonim",
    "antworten": "Menjawab",
    "attachment_gaia_hint": "Lampiran GaiaCOM tetap terenkripsi ujung ke ujung.",
    "attachment_smtp_hint": "SMTP lama memblokir lampiran yang dapat dieksekusi/seperti skrip dan menyimpan email sebagai tidak aman.",
    "attachments": "Lampiran",
    "auffaellig": "Nyata",
    "auth_beta_notice": "Fase pengujian beta: GaiaCOM sedang diuji secara aktif. Kesalahan mungkin terjadi; mengamankan benih penting dan meninjau dengan cermat alur kerja rahasia.",
    "auth_btn_login": "Muat identitas & masuk",
    "auth_btn_register": "Daftarkan & buat kripto",
    "auth_copied": "Disalin",
    "auth_copy_seed": "Salin benih",
    "auth_generate_seed": "Hasilkan benih",
    "auth_headline": "GaiaCOM adalah protokol email dan sistem komunikasi kuantum aman pertama yang dibangun untuk kemanusiaan.",
    "auth_kicker": "Komunikasi Aman Pasca-Quantum",
    "auth_mnemonic": "Ungkapan mnemonik",
    "auth_mnemonic_placeholder": "12 kata dipisahkan dengan spasi...",
    "auth_password": "kata sandi",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Kunci pribadi tidak akan meninggalkan perangkat Anda. Hanya penerima yang dituju yang dapat mendekripsi konten.",
    "auth_proof_gaiadata_desc": "Tanpa Pengetahuan: Anda tetap mengontrol data Anda. Metadata diminimalkan dan tidak digunakan sebagai profil teks biasa.",
    "auth_proof_gaiadrop_desc": "Orang luar dapat mengirim pesan teks rahasia ke GaiaID Anda tanpa akun.",
    "auth_proof_gaiaproof_desc": "Bukti pengiriman dan integritas menunjukkan bahwa ciphertext, pengirim dan stempel waktu belum dirusak.",
    "auth_proof_gaiavault_desc": "Catatan pribadi, catatan pemulihan, dan catatan keamanan tetap dienkripsi secara lokal.",
    "auth_proof_hybrid_desc": "Quantum Shield: Enkripsi hibrid dengan ML-KEM dan X25519 melindungi terhadap serangan masa kini dan risiko simpan sekarang-dekripsi-nanti.",
    "auth_secure_mail": "Amankan Surat Federasi Quantum",
    "auth_subline": "GaiaCOM adalah sistem komunikasi kuantum aman untuk email, obrolan, ruang krisis, GaiaDrop, dan file keamanan lokal. Kunci pribadi tetap ada di perangkat Anda, konten dienkripsi secara end-to-end, dan bukti dapat diekspor tanpa teks biasa.",
    "auth_success_btn": "Masuk sekarang",
    "auth_success_text": "Akun GaiaCOM Anda telah dibuat. Kuncinya diambil secara lokal dari seed Anda dan tidak disimpan di server.",
    "auth_success_title": "Pendaftaran berhasil",
    "auth_tab_drop": "Gaia Jatuhkan",
    "auth_tab_login": "Masuk/Akun",
    "auth_toggle_login": "Akun sudah ada",
    "auth_toggle_register": "Buat akun baru",
    "auth_usecase_text": "Cocok untuk pengacara, perusahaan, otoritas, jurnalis, pelapor, dan kasus keamanan swasta.",
    "auth_usecase_title": "Dibangun untuk komunikasi sensitif",
    "auth_username": "nama belakang",
    "auth_username_placeholder": "Masukkan nama...",
    "auth_value_chat": "Obrolan E2E",
    "auth_value_drop": "Jatuhkan Aman",
    "auth_value_mail": "Surat aman",
    "auth_value_rooms": "Kamar Gaia",
    "bestaetigen": "Mengonfirmasi",
    "bestaetigt": "Dikonfirmasi",
    "bio_status": "Biografi/Status",
    "biography": "biografi",
    "change_password_desc": "Mengubah kata sandi masuk sisi server Anda. Frase pemulihan lokal Anda tetap dilindungi secara terpisah oleh kata sandi brankas/buka kunci Anda.",
    "change_password_menu_desc": "Perbarui kata sandi masuk GaiaCOM.",
    "change_password_title": "Ubah Kata Sandi",
    "channel_id": "ID Saluran",
    "channel_name_label": "Nama saluran",
    "chat_deleted_hidden": "Obrolan dihapus dan disembunyikan.",
    "chat_input_placeholder": "Masukkan pesan aman...",
    "chat_start_hint": "Mulailah percakapan! Semua pesan obrolan dienkripsi dengan kuantum aman E2E.",
    "choose_avatar": "Pilih avatar",
    "ciphertext_hash": "Hash teks tersandi",
    "clear_chat": "Obrolan kosong",
    "clear_for_everyone": "Kosong untuk semua orang",
    "clear_for_me": "Kosong hanya untukku",
    "click_to_write_mail": "Klik untuk menulis email",
    "click_top_right": "Klik di kanan atas",
    "close": "Menutup",
    "code_kopieren": "Salin kode",
    "code_kopieren_success": "Kode disalin",
    "confirm_clear_channel_desc": "Apakah Anda ingin menghapus saluran ini dari tampilan lokal Anda?",
    "confirm_clear_channel_title": "Saluran kosong",
    "confirm_clear_chat": "Apakah Anda ingin mengosongkan obrolan ini?",
    "confirm_clear_chat_desc": "Apakah Anda ingin mengosongkan obrolan ini?",
    "confirm_clear_chat_title": "Obrolan kosong",
    "confirm_clear_everyone": "Apakah Anda ingin mengosongkan obrolan untuk kedua pasangan? (OK = Untuk semuanya, Batal = Hanya untuk saya)",
    "confirm_delete_everyone": "Apakah Anda ingin menghapus pesan untuk kedua pasangan? (OK = Untuk semuanya, Batal = Hanya untuk saya)",
    "confirm_delete_msg": "Apakah Anda ingin menghapus pesan ini?",
    "confirm_delete_msg_desc": "Apakah Anda ingin menghapus pesan obrolan ini?",
    "confirm_delete_msg_title": "Hapus pesan",
    "confirm_new_password": "Konfirmasikan kata sandi baru",
    "copy": "Menyalin",
    "create_btn": "Membuat",
    "create_channel_title": "Buat saluran",
    "create_group_is_crisis": "Tandai sebagai area krisis",
    "create_group_title": "Buat grup baru",
    "crypto_lock_desc": "Mengontrol kapan GaiaCOM menghapus kunci kripto lokal dari memori.",
    "crypto_lock_menu_desc": "Kontrol pengatur waktu muat ulang dan tidak aktif.",
    "crypto_lock_title": "Kunci kriptografi",
    "crypto_session_duration": "Tidak terkunci setelah memuat ulang",
    "crypto_session_duration_desc": "Hanya membiarkan sesi kripto tetap terbuka di tab browser ini selama durasi yang dipilih.",
    "cryptographic_fingerprint": "Sidik jari kriptografi",
    "current_password": "Kata Sandi Saat Ini",
    "data_minimization": "Minimalkan data",
    "decrypt_failed": "Tidak dapat diuraikan",
    "delete": "Menghapus",
    "delete_account_button": "Hapus akun tanpa dapat ditarik kembali",
    "delete_account_confirm_label": "Masukkan DELETE untuk mengonfirmasi",
    "delete_account_confirmation_error": "Konfirmasi kata sandi dan DELETE diperlukan.",
    "delete_account_desc": "Mode ini secara permanen menghancurkan akun, identitas, sesi perangkat, data GaiaDrop, metadata unggahan, dan pesan yang dapat diatribusikan di sisi server.",
    "delete_account_done_desc": "Semua data GaiaCOM yang dapat dialihkan telah dihapus.",
    "delete_account_done_title": "Akun dihapus",
    "delete_account_menu_desc": "Hancurkan akun dan data terkait.",
    "delete_account_not_authenticated": "Tidak ada akun aktif.",
    "delete_account_title": "Hapus akun",
    "delete_for_everyone": "Hapus untuk semua orang",
    "delete_for_me": "Hapus hanya untukku",
    "device_current": "Perangkat ini",
    "device_last_seen": "Terakhir",
    "device_logout": "Keluar",
    "device_sessions_desc": "Periksa sesi aktif dan batalkan pendaftaran perangkat yang tidak lagi Anda percayai.",
    "device_sessions_empty": "Tidak ada perangkat yang ditemukan.",
    "device_sessions_menu_desc": "Kelola dan akhiri sesi aktif.",
    "device_sessions_title": "Perangkat terdaftar",
    "device_since": "Sejak",
    "display_name": "Nama tampilan",
    "drop_address_copied": "Alamat GaiaDrop disalin.",
    "drop_btn_decrypting": "Kotak masuk sedang didekripsi...",
    "drop_btn_load": "Muat Kotak Masuk GaiaDrop",
    "drop_delete_desc": "Apakah Anda benar-benar ingin menghapus penurunan ini secara permanen?",
    "drop_delete_title": "Hapus GaiaDrop",
    "drop_desc": "Saluran tanpa pengetahuan hanya berupa teks untuk pemberitahuan eksternal, pengungkapan yang bertanggung jawab, dan laporan rahasia. Pihak eksternal dapat mengirim pesan tanpa akun menggunakan GaiaID Anda.",
    "drop_empty": "Belum ada pesan GaiaDrop yang dimuat.",
    "drop_id": "Jatuhkan ID:",
    "drop_own_address": "Alamat GaiaDrop Anda",
    "drop_proof": "BUKTI JATUH",
    "drop_title": "Kotak Masuk Aman GaiaDrop",
    "dunkler_modus": "Mode gelap",
    "e2e_chat_room_open": "Buka ruang obrolan E2E",
    "edit_profile": "Sunting profil",
    "edit_profile_desc": "Sesuaikan nama tampilan, bio, dan avatar.",
    "einladungscode": "Kode undangan",
    "enter_fingerprint_chars_confirm": "Masukkan karakter sidik jari yang diminta untuk mengonfirmasi.",
    "envelope_hash": "Hash amplop",
    "erasability": "kemampuan untuk dihapus",
    "erfolg": "Kesuksesan",
    "exclude_plaintext": "Ekspor tanpa teks biasa",
    "export_disclosure": "Ekspor kasus keamanan",
    "export_package_desc": "Hanya sertakan teks biasa jika pengungkapan ini memang disengaja.",
    "export_package_title": "Ekspor paket keamanan",
    "fehler": "Kesalahan",
    "gaiacom_reader": "Pembaca GaiaCOM",
    "gaiadrop_inbox_title": "Kotak Masuk GaiaDrop",
    "gaiavault": "Gudang Gaia",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM meminimalkan metadata, menjaga kunci pribadi tetap lokal, mengenkripsi konten end-to-end dan memungkinkan penghapusan akun sepenuhnya.",
    "gdpr_home_title": "100% mematuhi GDPR",
    "gdpr_reason_delete": "Penghapusan akun menghapus akun, identitas, sesi lokal, dan data yang dapat ditetapkan di sisi server.",
    "gdpr_reason_e2ee": "Konten pribadi tetap dapat didekripsi hanya untuk penerima yang dituju.",
    "gdpr_reason_minimal": "Metadata hanya digunakan untuk perutean, pengiriman, dan kredensial keamanan.",
    "gdpr_reason_zero_knowledge": "Kunci pribadi dan data pemulihan tetap berada di bawah kendali pengguna secara lokal.",
    "gesendet": "Terkirim",
    "gesperrt_verdaechtig": "Dilarang / Mencurigakan",
    "group_delete_desc": "Apakah Anda benar-benar ingin menghapus grup ini secara permanen? Semua saluran dan pesan di grup ini akan dihapus.",
    "group_delete_title": "Hapus grup",
    "group_description": "Keterangan",
    "group_icon_label": "Ikon grup/avatar",
    "group_name": "Nama grup",
    "group_settings_avatar": "Avatar",
    "group_settings_desc": "Keterangan",
    "group_settings_is_crisis": "Tandai sebagai area krisis",
    "group_settings_name": "Nama grup",
    "group_settings_title": "Pengaturan grup",
    "groups_empty_desc": "Ciptakan ruang kerja yang aman untuk proyek, krisis, atau komunikasi tim.",
    "groups_empty_title": "Belum ada obrolan grup",
    "gruppe_beitreten": "Bergabung dengan grup",
    "gruppe_erstellen": "+ Buat grup",
    "gruppe_verlassen": "Keluar dari grup",
    "gruppen_chats": "Obrolan grup",
    "heller_modus": "Modus terang",
    "how_to_receive_drops": "Bagaimana cara saya menerima tetes?",
    "identitaets_assistent": "Asisten Identitas",
    "inactivity_lock_duration": "Kunci saat tidak aktif",
    "inactivity_lock_duration_desc": "Setelah periode tidak ada input ini, GaiaCOM akan otomatis terkunci secara kriptografis.",
    "inactivity_lock_notice": "GaiaCOM telah diblokir secara kriptografis karena tidak ada aktivitas.",
    "include_plaintext": "Sertakan teks biasa",
    "invite_code_label": "Kode undangan",
    "join_group_title": "Bergabunglah dengan grup",
    "kanaele": "Saluran",
    "kanal_erstellen": "+ saluran",
    "kein_chat_ausgewaehlt": "Tidak ada obrolan yang dipilih",
    "kein_kanal_ausgewaehlt": "Tidak ada saluran yang dipilih",
    "keine_gruppe_ausgewaehlt": "Tidak ada grup yang dipilih",
    "keine_mails": "Tidak ada email yang tersedia.",
    "key_change_warn_desc": "Kunci publik kontak ini telah berubah. Periksa sidik jari sebelum mempercayainya.",
    "key_change_warn_title": "Peringatan kriptografi",
    "key_change_warning_changed": "telah berubah. Ini mungkin pertanda serangan man-in-the-middle!",
    "key_change_warning_msg": "Kunci identitas untuk kontak tersebut",
    "key_transparency": "Transparansi Utama",
    "kopiert": "Disalin",
    "kryptographische_schluessel": "Kunci kriptografi",
    "kryptographische_schluessel_desc": "Tampilkan kunci pribadi dan frase benih cadangan.",
    "laden": "Memuat...",
    "leeren": "Kosong",
    "loading": "Memuat...",
    "local_key_vault": "Gudang kunci lokal",
    "local_keys_label": "Kunci lokal",
    "lock_on_reload": "Selalu kunci setelah memuat ulang",
    "logout": "Keluar",
    "mail_compose": "Tulis email",
    "mein_profil": "Profil saya",
    "melden": "Laporan",
    "menu": "menu",
    "message": "Berita",
    "message_id": "ID pesan",
    "message_pin": "Pin",
    "message_pinned_title": "Pesan yang disematkan",
    "message_react": "Bereaksi",
    "message_reply": "Menjawab",
    "message_replying_to": "Jawaban untuk",
    "message_save": "Menyimpan",
    "message_saved": "Disimpan",
    "message_to_channel": "Pesan ke",
    "message_unpin": "Menyelesaikan",
    "message_unsave": "Jangan simpan",
    "mitglied": "Anggota",
    "mitglieder": "anggota",
    "ml_kem": "ML-KEM",
    "neue_mail": "email baru",
    "never_auto_lock": "Tidak pernah secara otomatis",
    "new_fingerprint": "Sidik jari baru",
    "new_identity": "Identitas baru",
    "new_password": "Kata sandi baru",
    "no_description": "Tidak ada deskripsi",
    "no_key_history": "Tidak ada riwayat kunci yang tercatat.",
    "no_specification": "Tidak ditentukan",
    "old_fingerprint": "Sidik jari lama",
    "open_privacy_imprint": "Buka lini cetak dan perlindungan data",
    "post_quantum_e2e": "E2E pasca-kuantum",
    "posteingang": "Kotak masuk",
    "powered_by": "Didukung oleh",
    "privacy_imprint_menu_desc": "Tampilkan GDPR, perlindungan data, dan pemberitahuan hukum.",
    "privacy_imprint_profile_desc": "GaiaCOM memproses konten komunikasi sesuai dengan prinsip minimalisasi data, enkripsi ujung ke ujung, dan kontrol kunci lokal.",
    "privacy_imprint_title": "Perlindungan data & pemberitahuan hukum",
    "profil": "profil",
    "profile_details": "Detail profil",
    "profile_settings_hint": "Pengaturan profil ditampilkan di panel kanan.",
    "profile_unlock_desc": "Demi alasan keamanan, Anda harus memasukkan kembali kata sandi untuk melihat kunci kriptografi pribadi Anda.",
    "proof_hash": "Bukti hash:",
    "public_drop_desc": "Amankan Drop untuk informasi teks eksternal tanpa akun GaiaCOM.",
    "public_drop_message": "Berita",
    "public_drop_message_placeholder": "Masukkan teks rahasia...",
    "public_drop_send": "Kirim GaiaDrop",
    "public_drop_sender": "Catatan pengirim opsional",
    "public_drop_sender_placeholder": "Nama, nomor file atau anonim",
    "public_drop_target": "Targetkan GaiaID",
    "quanten_chat": "Obrolan Kuantum",
    "quantum_secure_exchange": "Pertukaran aman kuantum melalui...",
    "quantum_secure_net": "Jaringan Aman Kuantum GaiaCOM (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "Jaringan GaiaCOM melindungi privasi Anda dengan protokol enkripsi hibrid multi-lapis yang terlindung dari serangan komputer kuantum di masa depan.",
    "quantum_shield_l1_desc": "Menggunakan standar FIPS 203 untuk merangkum kunci bersama simetris. Mencegah perekaman pasif dan dekripsi selanjutnya (“Simpan Sekarang, Dekripsi Nanti”) oleh komputer kuantum.",
    "quantum_shield_l1_title": "1. Perlindungan Pasca-Quantum (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Prosedur pertukaran kunci Diffie-Hellman klasik dan sangat cepat yang berfungsi sebagai lapisan keamanan tambahan dalam prosedur hibrid.",
    "quantum_shield_l2_title": "2. Kriptografi Kurva Elips (X25519)",
    "quantum_shield_l3_desc": "Setiap pesan dan setiap amplop Federasi ditandatangani secara kriptografis untuk memverifikasi keaslian pengirimnya.",
    "quantum_shield_l3_title": "3. Tanda Tangan Digital (Ed25519)",
    "quantum_shield_l4_desc": "Mengenkripsi konten pesan secara simetris dan mengikat erat pengirim, penerima, dan metadata ke dalam Data Tambahan yang Diotentikasi (AAD) untuk mencegah serangan replay.",
    "quantum_shield_l4_title": "4. Otentikasi AAD (AES-256-GCM)",
    "quantum_shield_status": "Status Perisai Kuantum",
    "receive_drops_step1": "Bagikan GaiaID Anda (misalnya menggunakan tombol salin di atas) dengan sumber eksternal.",
    "receive_drops_step2": "Ini memanggil halaman login instance GaiaCOM Anda dan beralih ke tab",
    "receive_drops_step3": "dan mengirim pesan terenkripsi mereka ke alamat Anda.",
    "receiver_gaia": "Penerima GaiaCOM",
    "receiver_smtp": "Penerima SMTP",
    "records_stored": "Catatan disimpan",
    "refresh": "Memperbarui",
    "report_abuse_desc": "Apakah Anda ingin melaporkan pesan ini dan mengirimkan bukti penyalahgunaan kriptografi ke server?",
    "report_abuse_title": "Laporkan penyalahgunaan",
    "reputation_status": "Status Reputasi",
    "room_chat_start_hint": "Mulailah percakapan! Semua pesan di saluran grup ini terdesentralisasi dengan enkripsi E2E yang aman untuk kuantum.",
    "room_policy_audit": "Jejak audit dan rotasi kunci aktif.",
    "room_policy_crisis": "Ruang krisis",
    "room_policy_e2ee": "Ruang tanpa pengetahuan. Brankas kuantum E2EE.",
    "room_policy_title": "Pedoman ruangan",
    "room_policy_zero_knowledge": "Kebijakan",
    "room_security_note_desc": "Semua perubahan penting divalidasi melalui Transparansi Kunci. Gunakan GaiaVault untuk log cadangan pribadi.",
    "room_security_note_title": "Catatan keamanan yang disematkan",
    "save_profile": "Simpan profil",
    "schluessel_entsperrt": "🔑 Kunci lagi kuncinya",
    "search_gaia_label": "Temukan alamat Gaia",
    "security_warning_title": "Peringatan keamanan",
    "select_channel_chat": "Pilih saluran dari sidebar kiri untuk mengobrol.",
    "select_contact_chat": "Pilih kontak dari panel kiri untuk memulai obrolan E2E yang aman kuantum.",
    "select_mail_read": "Pilih email dari daftar untuk membaca konten aman kuantumnya atau membuat pesan baru.",
    "senden": "Mengirim",
    "sender_signature": "Tanda Tangan Pengirim",
    "server_log": "Catatan server:",
    "server_received": "Server Diterima",
    "session_lock": "Kunci sesi",
    "setup_address_keys": "Buat alamat dan set kunci",
    "setup_profile": "Atur di profil",
    "smtp_inbox_title": "penerimaan SMTP",
    "smtp_legacy_badge": "SMTP Lama / Tidak Aman",
    "smtp_mode_option": "Jembatan SMTP lama",
    "smtp_security_warning": "Email ini dikirimkan melalui protokol SMTP klasik yang tidak terenkripsi. Tidak ada enkripsi ujung ke ujung yang aktif.",
    "smtp_security_warning_desc": "Pesan ini meninggalkan ruang keamanan GaiaCom. Pengiriman SMTP tidak memberikan jaminan end-to-end asli GaiaCom, tidak ada jaminan TrustMesh, dan tidak ada jaminan Godmode dari gateway.",
    "spam_verdacht": "Spam/kecurigaan",
    "spam_warning_desc": "Pesan ini memiliki sinyal reputasi yang mencurigakan.",
    "spam_warning_title": "Peringatan spam",
    "speichern": "Menyimpan",
    "sperren": "Kunci keluar",
    "standard_group_status": "Obrolan grup standar (terenkripsi E2EE)",
    "status": "status",
    "subject": "Tentang",
    "suchen": "Temukan alamat Gaia baru...",
    "tage": "hari",
    "time_unknown": "Waktu tidak diketahui",
    "transmission_mode": "Modus perpindahan",
    "trust_age": "Usia kepercayaan",
    "trust_passport_title": "Percayai Paspor",
    "unbestaetigt": "Belum dikonfirmasi",
    "unknown_sender": "Tidak dikenal",
    "unlock_btn": "Membuka kunci",
    "unlock_btn_profile": "Membuka kunci",
    "unlock_desc": "File kunci pribadi Anda disimpan terenkripsi. Masukkan kata sandi Anda untuk memuat kunci kriptografi di memori saja.",
    "unlock_logout": "Keluar dan tutup kunci lokal",
    "unlock_title": "Buka Kunci Identitas",
    "untrusted": "Tidak dapat dipercaya",
    "update_password": "Perbarui kata sandi",
    "upload_avatar_btn": "Unggah gambar (Disanitasi)",
    "vault_btn_encrypt": "Enkripsi catatan",
    "vault_btn_lock": "Kunci aman",
    "vault_btn_unlock": "Buka kunci dengan aman",
    "vault_copied_success": "Disalin ke papan klip",
    "vault_decrypted_content": "Konten yang didekripsi",
    "vault_desc": "Gudang terenkripsi lokal untuk cadangan pemulihan, catatan identitas, akses server, kontak darurat, catatan hukum, peristiwa keamanan, dan log pribadi.",
    "vault_empty": "Belum ada catatan aman yang disimpan.",
    "vault_locked_pane_notice": "Brankas terkunci. Silakan buka kunci di sebelah kanan.",
    "vault_new_record": "Rekor aman baru",
    "vault_pwd_placeholder": "Masukkan Kata Sandi Gudang...",
    "vault_record_body": "Rekam konten",
    "vault_record_body_placeholder": "Masukkan konten rekaman terenkripsi...",
    "vault_record_category": "kategori",
    "vault_record_title": "Judul rekaman",
    "vault_record_title_placeholder": "Judul catatan aman",
    "vault_title": "Catatan Aman GaiaVault",
    "verify_new_fingerprint_hint": "Periksa sidik jari baru sebelum menerima kunci.",
    "vertrauenswuerdig": "Terpercaya",
    "vision_gaia_technology": "VisiGaiaTeknologi",
    "von": "Dari",
    "warnung": "peringatan",
    "wizard_address": "alamat",
    "wizard_back": "Kembali",
    "wizard_check1": "Saya telah menyimpan benih saya dengan aman.",
    "wizard_custom_domain": "Gunakan domain Anda sendiri",
    "wizard_desc1": "GaiaCOM tidak menyimpan kunci pribadi di sisi server. Tanpa Mnemonic Seed, tidak ada yang bisa memulihkan pesan yang hilang.",
    "wizard_desc2": "Alamat Anda menentukan simpul gabungan yang melaluinya amplop terenkripsi dirutekan.",
    "wizard_fallback": "Node cadangan",
    "wizard_finish": "Selesaikan penyiapan",
    "wizard_next": "Lebih jauh",
    "wizard_server_domain": "Domain simpul server",
    "wizard_step1": "1. Benih Cadangan",
    "wizard_step2": "2. Alamat & Server",
    "wizard_title1": "Cadangkan kunci pemulihan",
    "wizard_title2": "Pilih alamat GaiaCOM",
    "write_message_placeholder": "Tulis pesan aman...",
    "you": "Anda",
    "zero_knowledge": "Pengetahuan nol",
    "zero_knowledge_encryption": "Enkripsi tanpa pengetahuan",
    "Chat fuer alle geleert": "Obrolan telah dikosongkan untuk semua peserta.",
    "Chat geleert": "Obrolan telah dihapus untuk kotak masuk lokal Anda.",
    "Nachricht fuer alle geloescht": "Pesan telah dihapus untuk semua peserta.",
    "Nachricht geloescht": "Pesan obrolan telah dihapus secara lokal dari kotak masuk Anda.",
    "anpinnen": "Pin",
    "chat_loeschen": "Hapus obrolan",
    "confirm_delete_chat_desc": "Apakah Anda yakin ingin menghapus dan menyembunyikan obrolan tersebut?",
    "confirm_leave_group_desc": "Apakah Anda benar-benar ingin keluar dari grup ini?",
    "entpinnen": "Membuka peniti",
    "group_deleted": "Grup berhasil dihapus.",
    "group_left": "Keluar dari grup dengan sukses.",
    "gruppe_loeschen": "Hapus grup",
    "loeschen": "Menghapus",
    "no_active_chats": "Tidak ada obrolan aktif. Cari kontak di atas untuk memulai obrolan.",
    "pinned": "Disematkan",
    "wizard_check_credentials": "Saya bertanggung jawab untuk menjaga keamanan data akses saya.",
    "wizard_check_is_beta": "Saya memahami bahwa GaiaCom adalah perangkat lunak beta.",
    "wizard_check_no_illegal": "Saya tidak akan menggunakan GaiaCom untuk tujuan yang melanggar hukum.",
    "wizard_check_no_uptime": "Saya memahami bahwa tidak ada jaminan ketersediaan.",
    "wizard_check_smtp_security": "Saya memahami bahwa pesan SMTP tidak memberikan keamanan penuh GaiaCom.",
    "wizard_check_terms_read": "Saya telah membaca Ketentuan Layanan Beta.",
    "wizard_step_terms": "Ketentuan Penggunaan",
    "wizard_terms_text": "Ketentuan Penggunaan GaiaCom dan Perjanjian Pengujian Beta (Fase Beta)\n\nPenyedia: VisionGaiaTechnology (selanjutnya disebut “Penyedia”)\nStatus: Tahap pengujian beta publik\nValiditas: Mulai 21 Juni 2026\n\n⚠️ CATATAN PALING PENTING SEBELUMNYA (HARAP BACA DENGAN TELITI)\nGaiaCom sedang dalam tahap pengujian beta publik. Meskipun terdapat langkah-langkah keamanan yang ekstensif, kebebasan dari kesalahan, ketersediaan berkelanjutan, atau keamanan absolut dari perangkat lunak dan infrastruktur yang mendasarinya tidak dapat dijamin. Gunakan dengan risiko Anda sendiri. Pengguna bertanggung jawab atas penyimpanan data akses mereka dengan aman (terutama kunci untuk GaiaVault) dan kepatuhan terhadap hukum yang berlaku.\n\n1. Subjek dan tujuan tahap pengujian beta\n1.1. Tujuan penyediaan: GaiaCom adalah layanan email dan obrolan baru berdasarkan kriptografi pasca-kuantum (PQC). Penyediaan pada tahap beta ditujukan khusus untuk pengujian teknis, simulasi beban, menemukan kesalahan program (bug) dan mengoptimalkan kemudahan penggunaan.\n1.2. Status beta: Pengguna mengetahui bahwa perangkat lunak yang ditawarkan adalah versi awal (perangkat lunak beta). Hal ini belum sepenuhnya dikembangkan secara teknis, tidak memenuhi standar produk akhir komersial dan dapat menyebabkan kesalahan, kehilangan data, penundaan transmisi atau kerusakan sistem.\n1.3. Tidak ada hak untuk melanjutkan: Penyedia berhak sewaktu-waktu menghentikan layanan secara keseluruhan atau sebagian, mengubah atau membatasi fungsi atau menghapusnya untuk sementara atau permanen tanpa memberikan alasan.\n\n2. Ketersediaan dan Penafian Garansi\n2.1. Tidak ada jaminan ketersediaan: GaiaCom disediakan tanpa jaminan ketersediaan atau uptime. Tidak ada hak atas ketersediaan layanan tanpa gangguan.\n2.2. Pengecualian jaminan: Perangkat lunak disediakan dalam kondisi terkini (“sebagaimana adanya”) dan bergantung pada ketersediaan. Sejauh diizinkan oleh undang-undang, klaim jaminan apa pun atas cacat material dan hukum pada perangkat lunak tidak termasuk. Secara khusus, tidak ada jaminan bahwa perangkat lunak tersebut bebas dari kesalahan, bebas dari malware, atau cocok untuk tujuan tertentu.\n\n3. Manajemen risiko dan kewajiban pengguna\n3.1. Larangan penyimpanan data penting: Pengguna berjanji untuk tidak secara eksklusif menyimpan atau mengirimkan melalui GaiaCom data bisnis apa pun yang penting, penting, diperlukan secara operasional, atau sensitif secara hukum (seperti file pasien, data keuangan yang sangat sensitif, atau rahasia yang diatur secara resmi). Layanan ini tidak boleh digunakan untuk infrastruktur di mana kegagalan yang tidak terduga dapat mengakibatkan cedera diri, kerusakan properti, atau kerugian finansial yang signifikan.\n3.2. Pencadangan yang bertanggung jawab sendiri: Pengguna bertanggung jawab untuk mencadangkan semua data yang diterima atau dikirim melalui GaiaCom yang ia perlukan dalam jangka panjang pada sistemnya sendiri yang independen (salinan cadangan). Penyedia tidak menjamin penyimpanan permanen atau pemulihan data di servernya.\n\n4. Fitur kriptografi dan GaiaVault\n4.1. Kriptografi pasca-kuantum (PQC): GaiaCom menerapkan proses enkripsi canggih dan berorientasi masa depan yang dirancang untuk menahan serangan dari komputer kuantum di masa depan. Namun, pengguna menyadari bahwa ini adalah bidang keilmuan yang dinamis dan baru. Keamanan yang mutlak dan tidak dapat disangkal tidak dapat dijamin berdasarkan kondisi ilmu pengetahuan dan teknologi saat ini. Istilah seperti “100% aman”, “tidak dapat dipecahkan”, atau “aman militer” secara tegas tidak dijamin.\n4.2. Tidak ada jaminan pemulihan (GaiaVault): GaiaCom mengandalkan konsep keamanan tanpa pengetahuan yang konsisten. Irisan enkripsi dan data akses tetap sepenuhnya berada dalam kendali pengguna (diamankan melalui GaiaVault).\nPENTING: Jika pengguna kehilangan kata sandi, frasa sandi, kunci pribadi, atau benih pemulihan, penyedia tidak memiliki kemampuan teknis untuk merekonstruksi atau mengatur ulang data ini. Hilangnya data akses ini pasti menyebabkan hilangnya akses yang tidak dapat dibatalkan ke akun pengguna dan semua data yang dienkripsi di dalamnya.\n4.3. Belum sepenuhnya diaudit: Perangkat lunak ini terus-menerus menjalani pemeriksaan keamanan internal, namun pada tahap beta ini, perangkat lunak belum menjalani audit keamanan eksternal akhir yang komprehensif oleh badan pengujian independen.\n\n5. Antarmuka, protokol lama, dan federasi\n5.1. SMTP Bridge Catatan: GaiaCom menawarkan kemampuan untuk berkomunikasi melalui protokol email klasik (seperti SMTP). Pengguna mengetahui bahwa pesan yang meninggalkan area keamanan asli GaiaCom (misalnya saat dikirim ke alamat konvensional @gmail.com atau @gmx.de) dikirim melalui server tidak terenkripsi atau pihak ketiga. Jaminan keamanan menyeluruh GaiaCom hanya berlaku sampai batas tertentu atau tidak berlaku sama sekali terhadap pesan lama yang keluar atau masuk secara eksternal.\n5.2. Catatan Federasi: Jika GaiaCom beroperasi pada jaringan gabungan, pesan dan data dapat melewati server pihak ketiga. Meskipun isi pesan tetap dilindungi oleh enkripsi ujung ke ujung, metadata (seperti waktu pengiriman, alamat IP server yang terlibat, dan alamat penerima) secara teknis dapat dilihat oleh operator server gabungan ini. Penyedia tidak mempunyai pengaruh terhadap praktik perlindungan data operator server pihak ketiga di jaringan gabungan.\n\n6. Penggunaan yang Dapat Diterima dan Aktivitas yang Dilarang\nPengguna berjanji untuk tidak menggunakan layanan secara tidak benar atau untuk tujuan ilegal. Secara khusus, hal-hal berikut ini dilarang:\n- Mendistribusikan, mengirim atau menghosting virus, malware, konten phishing, atau perangkat lunak berbahaya lainnya.\n- Menggunakan Layanan untuk melakukan serangan penolakan layanan (DDoS) atau pengiriman massal yang tidak diminta (spam).\n- Menyalahgunakan sistem untuk melakukan penipuan.\n- Distribusi atau pertukaran konten ilegal, khususnya penggambaran pelecehan seksual terhadap anak-anak (CSAM), propaganda teroris, seruan kekerasan atau konten kriminal lainnya.\n\n7. Sistem pelaporan penyalahgunaan\n7.1. Melaporkan perilaku kasar: Pengguna memiliki kesempatan untuk melaporkan komunikasi yang kasar atau aktivitas ilegal melalui sistem penyalahgunaan terintegrasi.\n7.2. Pemrosesan laporan: Untuk memastikan perlindungan terhadap penyalahgunaan, laporan yang masuk dapat dianalisis secara teknis (dengan tetap menjaga batas privasi dan enkripsi). Hal ini dapat menyebabkan penangguhan sementara atau permanen terhadap akun pengguna atau alamat IP jika terbukti terjadi pelanggaran terhadap ketentuan penggunaan ini.\n\n8. Batasan Tanggung Jawab\n8.1. Standar pertanggungjawaban: Perangkat lunak beta disediakan secara gratis. Menurut aturan hukum mengenai sumbangan atau pinjaman, penyedia hanya bertanggung jawab atas kesengajaan (kerusakan yang disengaja) dan kelalaian berat.\n8.2. Pengecualian tanggung jawab atas kehilangan data: Tanggung jawab atas hilangnya data dikecualikan kecuali kerugian tersebut disebabkan secara sengaja atau karena kelalaian besar oleh penyedia dan pengguna telah memenuhi kewajibannya untuk memitigasi kerusakan melalui pencadangan rutin (di luar GaiaCom).\n8.3. Batasan hukum: Batasan tanggung jawab di atas tidak berlaku untuk cedera terhadap nyawa, tubuh, atau kesehatan, atau tanggung jawab berdasarkan Undang-Undang Kewajiban Produk.\n\n9. Sumber Terbuka\nKomponen, pustaka, atau aplikasi klien GaiaCom tertentu mungkin dilisensikan berdasarkan lisensi sumber terbuka (misalnya GPL, MIT, Apache). Ketentuan lisensi masing-masing komponen ini tetap tidak terpengaruh oleh ketentuan penggunaan ini dan dapat dilihat di repositori kode sumber terkait.\n\n10. Pengendalian dan Kepatuhan Ekspor\nPengguna menyadari bahwa perangkat lunak kriptografi mungkin tunduk pada kontrol ekspor yang ketat dan batasan hukum. Pengguna bertanggung jawab untuk memastikan bahwa penggunaan GaiaCom tidak melanggar hukum, pembatasan impor/ekspor, atau peraturan kriptografi di negara tempat tinggalnya masing-masing.\n\n11. Pemberitahuan perlindungan data (versi singkat untuk beta)\n11.1. Pengumpulan data minimal: Sebagai bagian dari fase beta, penyedia hanya mengumpulkan data yang benar-benar diperlukan untuk pengoperasian teknis, pemecahan masalah, dan pengembangan lebih lanjut (misalnya file log server untuk diagnosis kesalahan).\n11.2. Tidak ada wawasan tentang konten: Berkat enkripsi zero-knowledge dan E2E yang konsisten, penyedia tidak pernah memiliki akses ke konten obrolan, email, atau kunci Anda yang disimpan di GaiaVault.\n11.3. Deklarasi perlindungan data terperinci: Peraturan perlindungan data terperinci ditautkan secara terpisah dan juga harus dipertimbangkan oleh pengguna sebelum mendaftar.\n\n12. Ketentuan akhir\n12.1. Hukum yang berlaku: Hukum Republik Federal Jerman berlaku, kecuali Konvensi PBB tentang Kontrak Penjualan Barang Internasional.\n12.2. Dapat berubah sewaktu-waktu: Karena GaiaCom sedang dalam pengembangan aktif, penyedia berhak untuk menyesuaikan ketentuan ini kapan saja dan berlaku di masa mendatang. Versi saat ini tersedia di aplikasi.",
    "wizard_terms_title": "Ketentuan Penggunaan GaiaCom dan Perjanjian Pengujian Beta (Fase Beta)",
    "node_operator": "Operator simpul",
    "search_channels": "Cari saluran...",
    "senior_reviewer": "Peninjau Senior",
    "trusted_reviewer": "Peninjau Tepercaya",
    "active_frequencies": "Frekuensi aktif",
    "connected_rooms": "RUANG YANG TERHUBUNG",
    "dashboard": "Dasbor",
    "empty_chats": "Tidak ada obrolan aktif yang tersedia.",
    "empty_messages": "Tidak ada pesan baru yang tersedia.",
    "encrypted": "Terenkripsi",
    "gaiacom_uplink": "Tautan UP GAIACOM",
    "install_app": "Instal aplikasi",
    "install_app_desc": "Untuk memulai cepat & mode offline",
    "kommandozentrale_alpha": "Pusat komando ALPHA",
    "network_online": "JARINGAN: ONLINE",
    "new_room": "Ruang baru",
    "no_frequencies_active": "Tidak ada frekuensi yang aktif. Ciptakan ruang baru untuk memulai komunikasi.",
    "no_id": "Tidak ada tanda pengenal",
    "open_chats": "Buka obrolan",
    "open_inbox": "Buka kotak masuk",
    "primary_identity": "IDENTITAS UTAMA",
    "recent_chats": "Obrolan baru",
    "recent_messages": "Berita terbaru",
    "session_encrypted": "Sesi dienkripsi: {name}",
    "session_secure": "STATUS: AMAN",
    "system_verlassen": "Sistem keluar",
    "write_message": "Tulis pesan",
    "onboarding_step_profile": "Profil",
    "onboarding_step_security": "Perlindungan",
    "onboarding_step_backup": "Cadangan",
    "onboarding_step_launch": "Mulai",
    "onboarding_loading_gaia_id": "Memuat Gaia-ID",
    "onboarding_setup_kicker": "Pengaturan Awal GaiaCom",
    "onboarding_profile_title": "Jadikan GaiaCom sebagai ruang Anda.",
    "onboarding_profile_desc": "Nama tampilan dan avatar Anda tetap dikontrol secara lokal dan dapat diubah di profil kapan saja.",
    "onboarding_security_title": "Apa yang dilindungi GaiaCom untuk Anda saat ini.",
    "onboarding_security_desc": "GaiaCom memisahkan identitas, kunci, pesan, dan status jaringan. Anda hanya melihat versi singkat pengguna di sini.",
    "onboarding_backup_title": "Cadangan adalah pintu keluar darurat Anda yang sebenarnya.",
    "onboarding_backup_desc": "Tanpa data pemulihan, tidak ada yang bisa menyelamatkan identitas Anda. Itulah inti dari keamanan ujung-ke-ujung yang nyata.",
    "onboarding_launch_title": "Siap. Apa yang ingin Anda lakukan pertama kali?",
    "onboarding_launch_desc": "Anda dapat langsung mulai atau mengakhiri tur panduan dan melanjutkan pekerjaan di dasbor.",
    "onboarding_display_name": "Nama Tampilan",
    "onboarding_display_name_placeholder": "Bagaimana GaiaCom harus menampilkan Anda?",
    "onboarding_select_avatar": "Pilih Avatar",
    "onboarding_sec_identity_title": "Identitas",
    "onboarding_sec_identity_desc": "Gaia-ID Anda adalah jangkar jaringan Anda. Kontak dapat mendeteksi pergantian kunci.",
    "onboarding_sec_messages_title": "Pesan",
    "onboarding_sec_messages_desc": "Konten didekripsi secara lokal. Pesan yang diedit menerima tanda tangan baru.",
    "onboarding_sec_network_title": "Jaringan",
    "onboarding_sec_network_desc": "Pusat Keamanan dan Pusat Pengaduan memperlihatkan risiko tanpa pintu belakang global.",
    "onboarding_sec_transparency_title": "Transparansi",
    "onboarding_sec_transparency_desc": "Mencatat peristiwa keamanan dalam protokol agar peringatan tetap dapat dilacak.",
    "onboarding_backup_notice_title": "Penting bagi Pengguna Biasa",
    "onboarding_backup_notice_desc": "Simpan data pemulihan Anda terpisah dari perangkat ini. Jika kehilangan kata sandi dan cadangan, GaiaCom akan sengaja tetap terkunci.",
    "onboarding_backup_consent": "Saya tahu bahwa cadangan saya sangat penting untuk pemulihan dan pergantian perangkat.",
    "onboarding_inbox_title": "Kotak Masuk",
    "onboarding_inbox_desc": "Membaca email dan menulis pesan pertama.",
    "onboarding_contacts_title": "Kontak",
    "onboarding_contacts_desc": "Memeriksa kontak pertama atau memulai obrolan.",
    "onboarding_channels_title": "Saluran",
    "onboarding_channels_desc": "Menemukan frekuensi publik.",
    "onboarding_security_title_card": "Pusat Keamanan",
    "onboarding_security_desc_card": "Melihat status GaiaShield.",
    "onboarding_later": "Nanti",
    "onboarding_back": "Kembali",
    "onboarding_continue": "Lanjutkan",
    "onboarding_complete_setup": "Selesaikan Pengaturan",
    "auth_legal_consent": "Saya telah membaca dan menyetujui kebijakan privasi serta syarat penggunaan.",
    "auth_show_terms": "Tampilkan syarat penggunaan",
    "auth_recovery_mode": "Mode Pemulihan",
    "auth_recovery_import_title": "Impor File Pemulihan",
    "auth_recovery_import_desc": "Pulihkan kunci GaiaCom Anda dari file cadangan yang dilindungi kata sandi. Setelah itu, mnemonik dan nama pengguna akan terisi secara otomatis.",
    "auth_recovery_file_pwd_placeholder": "Kata sandi file pemulihan",
    "auth_recovery_local_pwd_placeholder": "Kata sandi pembuka kunci lokal baru minimal 12 karakter",
    "auth_recovery_importing": "Mengimpor...",
    "auth_recovery_decrypt": "Dekripsi Pemulihan",
    "auth_back_to_login": "Kembali ke login",
    "auth_terms_title": "Syarat Penggunaan GaiaCom Beta",
    "auth_terms_close": "Tutup",
    "auth_cookie_title": "GaiaCOM tetap berdaulat.",
    "auth_cookie_desc": "Kami hanya menggunakan penyimpanan lokal yang diperlukan secara teknis untuk bahasa, sesi, dan keamanan. Tidak ada pelacakan, cookie iklan, atau profil pihak ketiga.",
    "auth_cookie_accept": "Dimengerti",
    "sc_explainer_title": "Apa yang sebenarnya dilindungi di sini?",
    "sc_explainer_desc": "GaiaShield adalah lapisan pelindung antara akun Anda, pesan Anda, dan jaringan. Ia tidak memutuskan konten, melainkan risiko teknis: manipulasi, upaya replay, akses tidak sah, pola login yang mencurigakan, dan transisi gateway yang tidak aman.",
    "sc_explainer_identity_desc": "Memeriksa anomali login, risiko sesi, dan akses ke identitas lain.",
    "sc_explainer_messages_desc": "Mendeteksi pola replay, amplop termanipulasi, dan ketiadaan fitur integritas.",
    "sc_explainer_network_desc": "Menandai risiko federasi, batas frekuensi, dan SMTP sebelum kepercayaan ditampilkan secara salah.",
    "sc_open_security_warnings": "Peringatan keamanan terbuka",
    "sc_opt_all": "Semua",
    "sc_opt_low": "Rendah",
    "sc_opt_medium": "Sedang",
    "sc_opt_high": "Tinggi",
    "sc_opt_critical": "Kritis",
    "sc_opt_failed_login": "Login Gagal",
    "sc_opt_auth_attack": "Serangan Autentikasi",
    "sc_opt_rate_limit": "Batas Tarif",
    "sc_opt_policy_violation": "Petunjuk Kebijakan",
    "sc_opt_message_replay": "Replay Pesan",
    "sc_node_security_data_unavailable": "Data keamanan node tidak tersedia",
    "sc_total_events": "Total Peristiwa",
    "sc_login_attacks": "Serangan Login",
    "sc_rate_limits_active": "Batas Tarif Aktif",
    "sc_smtp_shield_hits": "Deteksi SMTP Shield",
    "sc_top_event_categories": "Kategori Peristiwa Teratas",
    "sc_no_entries": "Tidak ada entri.",
    "sc_node_audit_log": "Log Audit Node (Baru-baru ini)",
    "sc_no_node_events": "Tidak ada peristiwa node.",
    "archiv": "Arsip",
    "entwuerfe": "Draf",
    "markiert": "Berbintang",
    "wichtig": "Penting",
    "snoozed": "Ditunda",
    "papierkorb": "Sampah",
    "spam": "Spam",
    "cancel": "Batal",
    "error": "Kesalahan",
    "success": "Sukses",
    "kopieren": "Salin",
    "block_contact": "Blokir Kontak",
    "unblock_contact": "Buka Blokir Kontak",
    "report_contact": "Laporkan Kontak",
    "check_fingerprint": "Verifikasi Sidik Jari",
    "export_encrypted": "Ekspor (Terenkripsi)",
    "export_gaiaproof": "Ekspor (GaiaProof)",
    "export_password_prompt": "Silakan masukkan kata sandi untuk mengenkripsi ekspor obrolan:",
    "export_success": "Obrolan berhasil diekspor and terenkripsi.",
    "export_failed": "Ekspor gagal: ",
    "gaiaproof_export_success": "Paket GaiaProof berhasil diekspor.",
    "gaiaproof_export_failed": "Ekspor GaiaProof gagal: ",
    "export_gaiaproof_confirm": "Apakah Anda ingin mengunduh paket GaiaProof dengan semua tanda tangan and bukti pengiriman server? Ini mungkin memakan waktu beberapa saat.",
    "group_settings_is_private": "Ruang Privat (tidak dapat dicari secara publik, hanya permintaan bergabung)",
    "group_settings_read_only": "Mode hanya baca (hanya pemilik and admin yang dapat menulis)",
    "group_settings_slow_mode": "Mode Lambat (cooldown pengiriman)",
    "gsn_title": "Umpan Sosial GSN",
    "gsn_node_feed": "Umpan Node",
    "gsn_following_feed": "Diikuti",
    "gsn_feed_empty": "Tidak ada postingan ditemukan.",
    "gsn_composer_placeholder": "Apa yang baru di federasi?",
    "gsn_post_btn": "Bagikan",
    "gsn_profile": "Profil Pengguna",
    "gsn_followers": "Pengikut",
    "gsn_following": "Diikuti",
    "gsn_bio": "Deskripsi / Bio:",
    "gsn_bio_label": "Deskripsi / Bio:",
    "gsn_display_name": "Nama Tampilan",
    "gsn_edit_profile": "Edit Profil",
    "gsn_save_profile": "Simpan",
    "gsn_add_image": "Tambah Gambar (Terenkripsi)",
    "gsn_add_emoji": "Sisipkan Emoji",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Ikuti",
    "gsn_unfollow": "Batal Ikuti",
    "gsn_repost": "Bagikan / Repost",
    "gsn_post_created": "Postingan berhasil dibagikan.",
    "gsn_image_uploaded": "Gambar berhasil terenkripsi and diunggah.",
    "gsn_upload_failed": "Unggah gambar gagal: ",
    "gsn_comment_placeholder": "Tulis komentar...",
    "gsn_delete_confirm_title": "Hapus postingan?",
    "gsn_delete_confirm_desc": "Apakah Anda yakin ingin menghapus postingan ini secara permanen?",
    "gsn_delete_comment_confirm_title": "Hapus komentar?",
    "gsn_delete_comment_confirm_desc": "Apakah Anda yakin ingin menghapus komentar ini secara permanen?",
    "gsn_report": "Laporkan",
    "gsn_report_title": "Laporkan pelanggaran",
    "gsn_report_category": "Kategori",
    "gsn_report_spam": "Spam / Iklan",
    "gsn_report_harassment": "Pelecehan / Ujaran Kebencian",
    "gsn_report_abuse": "Penyalahgunaan",
    "gsn_report_illegal": "Konten ilegal",
    "gsn_report_severity": "Tingkat Keparahan",
    "gsn_report_low": "Rendah",
    "gsn_report_medium": "Sedang",
    "gsn_report_high": "Tinggi",
    "gsn_report_comment": "Komentar tambahan",
    "gsn_report_submit": "Laporkan",
    "gsn_report_submitted": "Laporan telah diajukan ke tata kelola.",
    "gsn_report_post": "Laporkan postingan",
    "report_group": "Laporkan grup",
    "report_group_reason_prompt": "Silakan masukkan alasan pelaporan (opsional):",
    "report_reason_prompt": "Silakan masukkan alasan pelaporan (opsional):",
    "report_failed": "Pelaporan gagal: ",
    "report_success": "Kontak dilaporkan.",
    "room_read_only_placeholder": "Hanya pemilik and admin yang dapat menulis",
    "read_only_active": "Mode hanya baca",
    "slow_mode_active": "Mode Lambat aktif",
    "kommandozentrale": "Pusat Komando",
    "kontakt_blockiert": "Kontak diblokir",
    "kontakt_freigegeben": "Kontak dibuka blokirnya",
    "mailbox_settings_title": "Pengaturan Mailbox",
    "mailbox_settings_desc": "Kelola tanda tangan, bahasa, filter email.",
    "mic_access_denied": "Akses mikrofon ditolak: ",
    "no_frequencies_active_desc": "Buat ruang baru untuk mulai berkomunikasi.",
    "key_changed_warning_title": "PERINGATAN KEAMANAN:",
    "key_changed_warning_desc": "Kunci identitas pengirim ini telah diperbarui atau berbeda dari kunci yang diketahui sebelumnya. Silakan verifikasi sidik jari melalui saluran aman lainnya.",
    "sc_col_category": "Kategori",
    "search_members": "Cari anggota...",
    "tab_general": "Umum",
    "tab_members": "Anggota",
    "tab_requests": "Permintaan",
    "tab_invites": "Undangan",
    "tab_logs": "Log",
    "auth_why_gaiacom": "Mengapa GaiaCOM?",
    "auth_why_gaiacom_desc": "Alternatif aman and terdesentralisasi untuk komunikasi rahasia Anda.",
    "auth_self_managed_id": "ID Mandiri",
    "auth_self_managed_id_desc": "Buat identitas kriptografis aman secara instan tanpa alamat email atau nomor telepon.",
    "auth_gaiadrop_secure_exchange": "Pertukaran aman tanpa akun",
    "auth_gaiadrop_benefit_e2ee": "Terenkripsi end-to-end",
    "auth_gaiadrop_benefit_no_login": "Tidak memerlukan login",
    "auth_gaiadrop_benefit_inbox": "Pengiriman langsung ke kotak masuk penerima",
    "auth_terms_of_use": "Syarat Penggunaan",
    "auth_terms_of_use_show": "Tampilkan Syarat Penggunaan",
    "auth_consent_privacy_terms": "Saya telah membaca dan menyetujui kebijakan privasi dan syarat penggunaan.",
    "auth_recovery_import_file": "Impor File Pemulihan",
    "auth_recovery_password": "Kata Sandi File Pemulihan",
    "auth_recovery_local_password": "Kata sandi buka kunci lokal baru minimal 12 karakter",
    "auth_recovery_decrypting": "Mendekripsi Pemulihan...",
    "auth_recovery_back": "Kembali ke login",
    "auth_cookie_sovereign": "GaiaCOM tetap berdaulat.",
    "auth_cookie_sovereign_desc": "Kami hanya menggunakan fitur penyimpanan lokal yang diperlukan secara teknis untuk bahasa, sesi, dan keamanan. Tanpa pelacakan, tanpa cookie iklan, tanpa profil pihak ketiga.",
    "auth_cookie_sovereign_accept": "Dimengerti",
    "unlock_keyboard_toggle": "⌨️ Gunakan Keyboard",
    "unlock_keypad_toggle": "🔢 Gunakan PIN Pad",
    "unlock_status_denied": "AKSES DITOLAK / COBA LAGI",
    "unlock_status_decrypting": "MENDEKRIPSI VAULT...",
    "unlock_status_secured": "VAULT AMAN / TERKUNCI",
    "auth_landing_nav_legal": "Hukum",
    "auth_landing_nav_beta": "Uji Beta",
    "auth_landing_card1_title": "Kriptografi Pasca-Kuantum (ML-KEM)",
    "auth_landing_card2_title": "100% Terdesentralisasi",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Perlindungan Metadata",
    "auth_landing_card5_title": "ID Dikelola Mandiri",
    "auth_landing_hybrid_title": "Kriptografi hari ini ditambah perlindungan terhadap hari esok.",
    "auth_landing_hybrid_desc": "GaiaCom menggabungkan pertukaran kunci klasik yang terbukti dengan enkapsulasi kunci pasca-kuantum. Pertahanan mendalam.",
    "auth_landing_x25519_desc": "Pertukaran kunci kurva elips yang cepat dan terbukti untuk perangkat saat ini dan sesi aman.",
    "auth_landing_mlkem_desc": "Enkapsulasi kunci pasca-kuantum untuk kerahasiaan jangka panjang terhadap skenario dekripsi di masa depan.",
    "auth_landing_cycle_title": "Server tidak melihat apa pun. Jaringan hanya membawa noise.",
    "auth_landing_step1_title": "Enkripsi Lokal",
    "auth_landing_step1_desc": "Pesan dienkripsi di perangkat pengirim sebelum mencapai jaringan atau server.",
    "auth_landing_step2_title": "Transportasi sebagai Blob",
    "auth_landing_step2_desc": "Paket berjalan sebagai noise kriptografis melalui node terfederasi atau lapisan penyimpanan terdesentralisasi.",
    "auth_landing_step3_title": "Penyimpanan Terfederasi",
    "auth_landing_step3_desc": "Tidak ada kotak surat terpusat sebagai sasaran. Data dipecah, terfederasi, dan sepenuhnya dienkripsi.",
    "auth_landing_step4_title": "Dekripsi Lokal",
    "auth_landing_step4_desc": "Hanya kunci privat penerima yang dapat mengubah blob kembali menjadi konten yang dapat dibaca.",
    "auth_landing_trinity_title": "Satu konsep protokol. Tiga tingkat infrastruktur.",
    "auth_landing_enterprise_desc": "Untuk korporasi, firma hukum, bisnis menengah, industri, dan perbankan swasta. Lingkaran komunikasi tertutup dengan kontrol administratif dan dukungan.",
    "auth_landing_enterprise_list1": "Kedaulatan internal dan administrasi pengguna",
    "auth_landing_enterprise_list2": "Node ter-self-host atau klaster berdaulat terkelola",
    "auth_landing_enterprise_list3": "SLA, dukungan, dan modul premium",
    "auth_landing_network_desc": "Jaringan terbuka untuk privasi digital. Tidak ada perdagangan data, melainkan infrastruktur untuk komunikasi bebas dan terenkripsi.",
    "auth_landing_network_list1": "Aplikasi klien open source",
    "auth_landing_network_list2": "Node terfederasi",
    "auth_landing_network_list3": "Tanpa kunci dekripsi terpusat",
    "auth_landing_defend_desc": "Infrastruktur keamanan tinggi khusus untuk otoritas, infrastruktur kritis, dan silo komunikasi terisolasi.",
    "auth_landing_defend_list1": "Penyebaran terisolasi dan luring (air-gapped)",
    "auth_landing_defend_list2": "Merek putih (white-label) dan audit kode sumber",
    "auth_landing_defend_list3": "Kedaulatan digital nasional",
    "auth_landing_gov_title": "Protokol terbuka. Eksekusi komersial. Pemisahan hukum yang jelas.",
    "auth_landing_gov_desc": "GaiaCom memisahkan protokol terbuka, klien terbuka, dan infrastruktur premium komersial. Kepercayaan berasal dari transparansi.",
    "auth_landing_price1_desc": "Biaya perlindungan bot untuk distribusi di AppStore/PlayStore.",
    "auth_landing_price2_desc": "Open Source gratis bagi pengguna yang memilih untuk mengompilasi sendiri.",
    "auth_landing_price3_desc": "Untuk bisnis menengah, firma hukum, dan tim yang sensitif.",
    "auth_landing_price4_desc": "Untuk korporasi, klaster ketersediaan tinggi, LDAP, dan akses root admin.",
    "auth_landing_license1_desc": "Transparansi kode maksimal bagi pengguna, fork, dan audit komunitas.",
    "auth_landing_license2_desc": "Perlindungan copyleft untuk mencegah penutupan komersial protokol.",
    "auth_landing_license3_desc": "LDAP, akses root admin, audit keamanan, SLA, dan logika bisnis khusus.",
    "auth_landing_final_title": "Komunikasi berdasarkan model tanpa kepercayaan.",
    "auth_landing_final_desc": "GaiaCom tidak sekadar menggantikan email. Ini memicu pertanyaan tentang mengapa komunikasi rahasia saat ini masih bergantung pada kotak surat terpusat dan server yang dapat dibaca.",
    "auth_landing_final_note": "Catatan: Halaman ini menjelaskan visi arsitektur dan peta jalan produk. Janji keamanan harus dikonfirmasi melalui audit sebelum digunakan secara produktif."




  };

export default id;